import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { typingComponent } from './typing/typing.component';
import { CardComponent } from './card/card.component';
import { AppMaterialModules } from '../material.module';

const COMPONENTS = [
  CardComponent,
  typingComponent
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    AppMaterialModules
  ],
  exports: [
    ...COMPONENTS
  ],
  declarations: [
    ...COMPONENTS
  ],
  providers: [ ]
})
export class ToolboxModule { }



// WEBPACK FOOTER //
// C:/dev/Perso/urmeo/src/app/toolbox/toolbox.module.ts